import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon, GlobeEuropeAfricaIcon } from '@heroicons/react/20/solid'
import {useLocation, useNavigate} from "react-router-dom";

const publishingOptions = [
  { title: 'United Kingdom', value:"uk", description: 'Discover Cloud Payroll Software for the United Kingdom, covering England, Scotland, Northern Ireland and Wales', current: true },
  { title: 'Malta', value:"mt", description: "Discover Malta's Leading Cloud Payroll Software", current: false },
  { title: 'Ireland', value:"ie", description: 'Coming Soon in Ireland - register your interest today.', current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function CountrySelector({
    onConfirm,
    noDefaultSelection
                                        }) {
  let location = useLocation();
  let navigate = useNavigate()

  const countryCode = location.pathname.split('/')[1]
  const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode : null
  const selected = !noDefaultSelection && publishingOptions.find(option => option.value === country)


  return (
    <Listbox value={country} onChange={() => {
      // location
    }}>
      {({ open }) => (
        <>
          <Listbox.Label className="sr-only">Change Country</Listbox.Label>
          <div className="relative">
            <div className="inline-flex divide-x divide-orange-700 rounded-md shadow-sm">
              <div className="inline-flex items-center gap-x-1.5 rounded-l-md bg-orange-600 px-3 py-2 text-white shadow-sm">
                <GlobeEuropeAfricaIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                <p className="text-sm font-semibold">{selected?.title ?? "Choose a Country"}</p>
              </div>
              <Listbox.Button className="inline-flex items-center rounded-l-none rounded-r-md bg-orange-600 p-2 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2 focus:ring-offset-gray-50">
                <span className="sr-only">Change published status</span>
                <ChevronDownIcon className="h-5 w-5 text-white" aria-hidden="true" />
              </Listbox.Button>
            </div>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute right-0 bottom-12 z-10 mt-2 w-72 origin-bottom-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {publishingOptions.map((option) => (
                  <Listbox.Option
                    key={option.title}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-orange-600 text-white' : 'text-gray-900',
                        'cursor-default select-none p-4 text-sm'
                      )
                    }
                    value={option}
                    onClick={() => {
                      onConfirm?.(option.value)
                      // navigate to the selected country
                      // TODO consider checking if current page has href equivalent - use that link if available
                      // navigate("/" + option.value + location.pathname.substring(3))
                      if (option.value !== country) {
                        navigate("/" + option.value)
                      }
                    }}
                  >
                    {({ selected, active }) => (
                      <div className="flex flex-col">
                        <div className="flex justify-between">
                          <p className={selected ? 'font-semibold' : 'font-normal'}>{option.title}</p>
                          {selected ? (
                            <span className={active ? 'text-white' : 'text-orange-600'}>
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </div>
                        <p className={classNames(active ? 'text-orange-200' : 'text-gray-500', 'mt-2')}>
                          {option.description}
                        </p>
                      </div>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  )
}